const X_ACCOUNT = 'rinsho_nurselab';

export default function PrivacyPolicyPage() {
  const h2 = 'text-lg font-bold text-gray-800 border-l-4 border-green-400 pl-3 mb-3';

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">プライバシーポリシー・免責事項</h1>
      <p className="text-gray-400 text-xs mb-10">最終更新日：2026年10月6日</p>

      <div className="space-y-10 text-gray-700 text-sm leading-relaxed">

        <section>
          <h2 className={h2}>サイト運営者</h2>
          <p>臨床ナースラボ（以下「当サイト」）は、現役看護師である管理者が個人で運営しています。特定の医療機関・企業・団体を代表するものではありません。</p>
        </section>

        <section>
          <h2 className={h2}>医療情報の取り扱いと免責事項</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>当サイトの記事・ツールは、看護師をはじめとする医療従事者の学習と臨床判断の補助を目的としたものであり、<span className="font-bold">医療行為・診断・治療の代替となるものではありません</span>。</li>
            <li>各ツールが算出するスコアや判定は入力内容に基づく目安です。実際の患者さんへの対応は、必ず所属施設の基準・医師の指示・最新のガイドラインに従って判断してください。</li>
            <li>内容の正確性には努めていますが、医学的知見やガイドラインは更新されます。当サイトの情報を利用したことによって生じたいかなる損害についても、当サイトは責任を負いかねます。</li>
            <li>当サイトのツールに患者さんの氏名・ID・個人を特定できる情報を入力しないでください。</li>
          </ul>
        </section>

        <section>
          <h2 className={h2}>アクセス解析ツールについて</h2>
          <p className="mb-2">当サイトでは、Googleによるアクセス解析ツール「Google Analytics」を利用しています。Google Analyticsはトラフィックデータの収集のためにCookieを使用しています。このデータは匿名で収集されており、個人を特定するものではありません。</p>
          <p>Cookieの使用はブラウザの設定で無効にできます。この規約に関して詳しくは、<a href="https://marketingplatform.google.com/about/analytics/terms/jp/" target="_blank" rel="noopener noreferrer" className="text-green-800 underline hover:text-green-600">Google Analyticsの利用規約</a>および<a href="https://policies.google.com/privacy?hl=ja" target="_blank" rel="noopener noreferrer" className="text-green-800 underline hover:text-green-600">Googleのプライバシーポリシー</a>をご覧ください。</p>
        </section>

        <section>
          <h2 className={h2}>広告・アフィリエイトについて</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>当サイトは、Amazon.co.jpを宣伝しリンクすることによってサイトが紹介料を獲得できる手段を提供することを目的に設定されたアフィリエイトプログラムである、<span className="font-bold">Amazonアソシエイト・プログラム</span>の参加者です。</li>
            <li>当サイトでは、第三者配信の広告サービス（Google AdSense等）を利用する場合があります。広告配信事業者は、ユーザーの興味に応じた広告を表示するためにCookieを使用することがあります。Cookieを無効にする方法やGoogle AdSenseに関する詳細は、<a href="https://policies.google.com/technologies/ads?hl=ja" target="_blank" rel="noopener noreferrer" className="text-green-800 underline hover:text-green-600">Googleの広告ポリシー</a>をご確認ください。</li>
            <li>記事内で紹介する書籍・商品は、管理者が実際に読んだ・使ったうえで役立つと判断したものを選んでいます。紹介料の有無は記事の内容に影響しません。</li>
          </ul>
        </section>

        <section>
          <h2 className={h2}>ツールで入力したデータの取り扱い</h2>
          <p>当サイト内のスコア算出ツール（NEWS2・DESIGN-R®・ブレーデンスケール等）は、入力内容をサーバーへ送信せず、お使いのブラウザ内でのみ計算しています。ページを閉じると入力内容は消えます。「褥瘡ログ」「創傷ログ」など記録を保存するツールは、データをお使いの端末内にのみ保存し、当サイトの運営者を含む第三者には送信されません。</p>
        </section>

        <section>
          <h2 className={h2}>著作権について</h2>
          <p>当サイトに掲載している文章・図表・ツールの著作権は、当サイトの管理者に帰属します。院内の勉強会・研修など非営利の教育目的で引用・利用いただく場合は、出典として「臨床ナースラボ」の名称とURLを明記してください。無断での転載・複製・再配布はご遠慮ください。DESIGN-R®は日本褥瘡学会の登録商標です。</p>
        </section>

        <section>
          <h2 className={h2}>リンクについて</h2>
          <p>当サイトはリンクフリーです。リンクを貼る際の許可や連絡は不要です。ただし、インラインフレームの使用や画像の直リンクはご遠慮ください。</p>
        </section>

        <section>
          <h2 className={h2}>お問い合わせ</h2>
          <p>当サイトに関するご質問・ご指摘・掲載内容の誤りのご連絡は、X（旧Twitter）のダイレクトメッセージでお受けしています。</p>
          <a href={`https://x.com/${X_ACCOUNT}`} target="_blank" rel="noopener noreferrer" className="inline-block mt-3 text-sm text-green-800 bg-green-100 hover:bg-green-200 px-4 py-2 rounded-full font-medium transition-colors">
            X：@{X_ACCOUNT} →
          </a>
        </section>

        <section>
          <h2 className={h2}>ポリシーの変更</h2>
          <p>当サイトは、必要に応じて本ポリシーの内容を変更することがあります。変更後の内容は本ページに掲載した時点で効力を生じます。</p>
        </section>

      </div>
    </div>
  );
}
